import styled from "styled-components";

export const EmptyLiveState = ({ scheduled = false }: { scheduled?: boolean }) => (
  <EmptyState>
    <EmptyImage viewBox="0 0 80 64" aria-hidden="true" focusable="false" width={80} height={64}>
      <path
        d="M14 4H66A10 10 0 0 1 76 14V42A10 10 0 0 1 66 52H40L27 61V52H14A10 10 0 0 1 4 42V14A10 10 0 0 1 14 4Z"
        fill="var(--user-accent-soft, #f3efff)"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <text x="40" y="34" textAnchor="middle" fill="currentColor" fontSize="18" fontWeight="600" letterSpacing="0.5">LIVE</text>
    </EmptyImage>
    <EmptyMessage>
      {scheduled ? "예정된 라이브 방송이 없습니다." : "현재 라이브 중인 방송이 없습니다."}
    </EmptyMessage>
  </EmptyState>
);

export const LiveSectionTitle = ({ scheduled = false }: { scheduled?: boolean }) => (
  <SectionTitle $scheduled={scheduled}>{scheduled ? "예정 라이브" : "라이브"}</SectionTitle>
);

export const LiveTabs = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`;

export const LiveTab = styled.button<{ $selected: boolean }>`
  min-height: 44px;
  padding: 10px 0;
  border: 0;
  border-bottom: 2px solid ${({ $selected }) => $selected ? "var(--user-accent, #7955f0)" : "transparent"};
  background: transparent;
  color: ${({ $selected }) => $selected ? "var(--user-accent, #7955f0)" : "var(--user-text-muted, #717171)"};
  font: inherit;
  font-size: 18px;
  font-family: var(--font-Pretendard-SemiBold);
  cursor: pointer;

  &:focus-visible { outline: 2px solid var(--user-accent, #7955f0); outline-offset: 3px; }
`;

const SectionTitle = styled.h2<{ $scheduled: boolean }>`
  margin: ${({ $scheduled }) => $scheduled ? "65px" : "10px"} 0 0;
  color: var(--user-text, #2d2d2d);
  font-size: 18px;
  font-weight: normal;
  font-family: var(--font-Pretendard-SemiBold);
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 80px 0 30px;
`;

const EmptyImage = styled.svg`
  display: block;
  width: 80px;
  height: 64px;
  margin-bottom: 16px;
  color: var(--user-accent, #6941d9);
  font-family: var(--font-Pretendard-SemiBold);
`;

const EmptyMessage = styled.p`
  margin: 0;
  color: var(--user-text-muted, #717171);
  font-size: 14px;
  font-family: var(--font-Pretendard-Regular);
  text-align: center;
`;
